import { makeStyles } from '@material-ui/core/styles';

import { draftModalActionButton } from '../policy-drafting.styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 580
  },
  subtitle: {
    marginTop: theme.spacing(4),
    color: theme.colorPalette.green_90
  },
  divider: {
    width: '100%',
    border: 'none',
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    margin: theme.spacing(4, 0)
  },
  error: {
    color: theme.colorPalette.green_90
  },
  note: {
    marginBottom: theme.spacing(4)
  },
  noteHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  noteIcon: {
    width: 16,
    height: 16
  },
  noteAuthor: {
    color: theme.colorPalette.green_90,
    lineHeight: 1.43
  },
  noteText: {
    display: 'block',
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(6),
    padding: theme.spacing(4),
    borderRadius: 4,
    backgroundColor: theme.colorPalette.white,
    color: theme.colorPalette.green_80,
    whiteSpace: 'pre-wrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4)
  },
  closeButton: draftModalActionButton(theme)
}));
